import { render, staticRenderFns } from "./InsuredHelpList.vue?vue&type=template&id=08ea7cce&"
import script from "./InsuredHelpList.vue?vue&type=script&lang=js&"
export * from "./InsuredHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports